var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbnailDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7581 25.5488C12.2525 25.5488 11.8197 25.3689 11.46 25.0091C11.1002 24.6493 10.92 24.2163 10.9194 23.71V11.7581H10V9.91938H14.5969V9H20.1131V9.91938H24.71V11.7581H23.7906V23.71C23.7906 24.2157 23.6107 24.6487 23.251 25.0091C22.8912 25.3695 22.4581 25.5494 21.9519 25.5488H12.7581ZM14.5969 21.8713H16.4356V13.5969H14.5969V21.8713ZM18.2744 21.8713H20.1131V13.5969H18.2744V21.8713Z",
    fill: "#FF1515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailDeleteIcon);
export default __webpack_public_path__ + "static/media/ThumbnailDeleteIcon.6641cc04ba33d3b623c0c5b057dabdcf.svg";
export { ForwardRef as ReactComponent };